<template>
  <input
    class="form-control"
    type="text"
    ref="product-options-input"
    @click="onClick"
    :readonly="isDisabled"
    >
</template>
<script>
import autoComplete from "js-autocomplete"
export default {
  name: "AsyncSearchInput",
  props: [
      "uuid",
      "value",
      "dataProvider",
      "dataMapper"
      ],
  data: () => ({
    autoComplete: "",
    itemSelected: false
  }),
  computed: {
    isDisabled() {
      return this.itemSelected
    }
  },
  created() {
    this.$parent.$on('setAsyncSearchInputData', this.onSetAsyncSearchInputData);
  },
  mounted() {
    this.initAutocomplete(this.onSelectCallback, this.dataProvider, this.dataMapper);
  },
  destroyed() {
    this.$parent.$off('setAsyncSearchInputData')
    if (this.autoComplete.destroy) {
      this.autoComplete.destroy();
    }
  },
  methods: {
    onSetAsyncSearchInputData(payload) {
      if (!!this.uuid && payload.uuid === this.uuid) {
        this.itemSelected = true
        this.$emit('input', payload.id)
        this.$refs['product-options-input'].value = payload.name
      }
    },
    onClick() {
      if (this.itemSelected) {
        this.itemSelected = false
        this.$emit('input', "")
        this.$refs['product-options-input'].value = ""
      }
    },
    onSelectCallback(val) {
      this.itemSelected = true
      this.$emit('input', val)
    },
    initAutocomplete: function(onSelectCallback, dataProvider, dataMapper) {
      this.autoComplete = new autoComplete({
          selector: this.$refs['product-options-input'],
          minChars: 2,
          delay: 100,
          cache: false,
          source: function(term, suggest){
              dataProvider(term,
                  (data) => {
                      suggest(
                          dataMapper(data)
                      )
                  }
              )
          },
          renderItem: function (item, search){
              return `<div class="autocomplete-suggestion" data-item-id="${item.id}" data-val="${item.name}">${item.name}</div>`
          },
          onSelect: function(e, term, item){
              e.preventDefault()
              onSelectCallback(item.getAttribute("data-item-id"));
          }
      });
    }
  }
}
</script>
<style lang="scss" scoped>

input:read-only {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/utils/AsyncSearchInput.vue